// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .ag-row:hover {
  background: yellow !important;
} */

.ag-theme-balham .ag-row-hover {
  background: rgba(13, 118, 51, 0.2) !important;
}
.ag-theme-balham .ag-row-selected {
  background: rgba(68, 133, 244, 0.14) !important;
  border-top: 1px solid rgba(66, 133, 244, 1) !important;
  border-bottom: 1px solid rgba(66, 133, 244, 1) !important;
}
.ag-theme-balham .ag-root {
  border: 1px solid #bdc3c7 !important;
}
.ag-theme-balham .ag-header {
  background-color: rgb(29, 89, 114) !important;
}
.ag-theme-balham .ag-header-cell {
  background-color: rgb(29, 89, 114) !important;
  color: white !important;
}
.ag-theme-balham .ag-header-cell-text {
  color: white !important;
}
.ag-theme-balham .ag-header .ag-header-row .ag-header-icon,
.ag-theme-balham .ag-header .ag-header-row .ag-icon-filter,
.ag-theme-balham .ag-header .ag-header-row .ag-icon-menu,
.ag-theme-balham .ag-header .ag-header-row .ag-icon-asc,
.ag-theme-balham .ag-header .ag-header-row .ag-icon-desc,
.ag-theme-balham .ag-header .ag-header-row .ag-icon-none {
  color: #ffffff !important;
}

.ag-theme-balham .ag-header .ag-header-cell-menu-button,
.ag-theme-balham .ag-header .ag-header-cell-menu-button .ag-icon {
  color: #ffffff !important;
}
.ag-theme-balham .ag-cell.varchar {
  text-align: right !important;
}
.ag-font-style {
  color: rgba(88, 89, 91, 1);
}

.ag-tool-panel {
  border: none;
}

/* .ag-row-focus{
  background: green !important;
} */

.ta-changed {
  background-color: rgba(246, 246, 13, 0.59);
}

/* .ag-header-cell-resize {
  display:none;
} */

.ag-header-cell-resize {
  background-color: transparent;
  opacity: 0.1;
}
.ag-row {
  /* border-style:none !important; */
}

.totalClass .ag-header-cell-label {
  justify-content: center;
}
.cellCenterClass {
  text-align: center;
}
.headerSize .ag-react-container {
  width: 100%;
}
.future {
  background: rgba(146, 185, 213, 0.19);
}

.ta-odd-row {
  background: rgba(245, 245, 245, 1) !important;
  border-style: none !important;
}

.ta-even-row {
  background: white !important;
  border-style: none !important;
}
.ta-final-group-row-odd {
  background: rgba(245, 245, 245, 1) !important;
  border-bottom: 1px solid grey !important;
}
.ta-final-group-row-even {
  background: white !important;
  border-bottom: 1px solid grey !important;
}
.ag-root-wrapper,
.ag-dnd-ghost {
  background-color: rgb(29, 89, 114);
}
`, "",{"version":3,"sources":["webpack://./src/style/agGrid.css"],"names":[],"mappings":"AAAA;;GAEG;;AAEH;EACE,6CAA6C;AAC/C;AACA;EACE,+CAA+C;EAC/C,sDAAsD;EACtD,yDAAyD;AAC3D;AACA;EACE,oCAAoC;AACtC;AACA;EACE,6CAA6C;AAC/C;AACA;EACE,6CAA6C;EAC7C,uBAAuB;AACzB;AACA;EACE,uBAAuB;AACzB;AACA;;;;;;EAME,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,0BAA0B;AAC5B;;AAEA;EACE,YAAY;AACd;;AAEA;;GAEG;;AAEH;EACE,0CAA0C;AAC5C;;AAEA;;GAEG;;AAEH;EACE,6BAA6B;EAC7B,YAAY;AACd;AACA;EACE,kCAAkC;AACpC;;AAEA;EACE,uBAAuB;AACzB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;AACb;AACA;EACE,qCAAqC;AACvC;;AAEA;EACE,6CAA6C;EAC7C,6BAA6B;AAC/B;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;AACA;EACE,6CAA6C;EAC7C,wCAAwC;AAC1C;AACA;EACE,4BAA4B;EAC5B,wCAAwC;AAC1C;AACA;;EAEE,kCAAkC;AACpC","sourcesContent":["/* .ag-row:hover {\n  background: yellow !important;\n} */\n\n.ag-theme-balham .ag-row-hover {\n  background: rgba(13, 118, 51, 0.2) !important;\n}\n.ag-theme-balham .ag-row-selected {\n  background: rgba(68, 133, 244, 0.14) !important;\n  border-top: 1px solid rgba(66, 133, 244, 1) !important;\n  border-bottom: 1px solid rgba(66, 133, 244, 1) !important;\n}\n.ag-theme-balham .ag-root {\n  border: 1px solid #bdc3c7 !important;\n}\n.ag-theme-balham .ag-header {\n  background-color: rgb(29, 89, 114) !important;\n}\n.ag-theme-balham .ag-header-cell {\n  background-color: rgb(29, 89, 114) !important;\n  color: white !important;\n}\n.ag-theme-balham .ag-header-cell-text {\n  color: white !important;\n}\n.ag-theme-balham .ag-header .ag-header-row .ag-header-icon,\n.ag-theme-balham .ag-header .ag-header-row .ag-icon-filter,\n.ag-theme-balham .ag-header .ag-header-row .ag-icon-menu,\n.ag-theme-balham .ag-header .ag-header-row .ag-icon-asc,\n.ag-theme-balham .ag-header .ag-header-row .ag-icon-desc,\n.ag-theme-balham .ag-header .ag-header-row .ag-icon-none {\n  color: #ffffff !important;\n}\n\n.ag-theme-balham .ag-header .ag-header-cell-menu-button,\n.ag-theme-balham .ag-header .ag-header-cell-menu-button .ag-icon {\n  color: #ffffff !important;\n}\n.ag-theme-balham .ag-cell.varchar {\n  text-align: right !important;\n}\n.ag-font-style {\n  color: rgba(88, 89, 91, 1);\n}\n\n.ag-tool-panel {\n  border: none;\n}\n\n/* .ag-row-focus{\n  background: green !important;\n} */\n\n.ta-changed {\n  background-color: rgba(246, 246, 13, 0.59);\n}\n\n/* .ag-header-cell-resize {\n  display:none;\n} */\n\n.ag-header-cell-resize {\n  background-color: transparent;\n  opacity: 0.1;\n}\n.ag-row {\n  /* border-style:none !important; */\n}\n\n.totalClass .ag-header-cell-label {\n  justify-content: center;\n}\n.cellCenterClass {\n  text-align: center;\n}\n.headerSize .ag-react-container {\n  width: 100%;\n}\n.future {\n  background: rgba(146, 185, 213, 0.19);\n}\n\n.ta-odd-row {\n  background: rgba(245, 245, 245, 1) !important;\n  border-style: none !important;\n}\n\n.ta-even-row {\n  background: white !important;\n  border-style: none !important;\n}\n.ta-final-group-row-odd {\n  background: rgba(245, 245, 245, 1) !important;\n  border-bottom: 1px solid grey !important;\n}\n.ta-final-group-row-even {\n  background: white !important;\n  border-bottom: 1px solid grey !important;\n}\n.ag-root-wrapper,\n.ag-dnd-ghost {\n  background-color: rgb(29, 89, 114);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
